import { Component, input, Input, InputSignal } from '@angular/core';
import {
  LocationOfDevicesUnrelatedToRoadStageForm
} from '../../forms/location-of-devices-unrelated-to-road-stage.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePickerComponent } from '../../../../../../../../common/date-picker/date-picker.component';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';
import {
  ExposedMapControlComponent
} from '../../../../../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import { ParcelsCrudComponent } from '../../../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { AlertComponent } from '../../../../../../../../common/alert/alert.component';
import { NgxMaskDirective } from 'ngx-mask';
import {
  RoadControlsSetComponent
} from '../../../../../common/components/road-controls-set/road-controls-set.component';

@Component({
  selector: 'app-location-of-devices-unrelated-to-road-occupation-stage-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DatePickerComponent,
    ValidationErrorsComponent,
    ExposedMapControlComponent,
    ParcelsCrudComponent,
    AlertComponent,
    NgxMaskDirective,
    RoadControlsSetComponent
  ],
  templateUrl: './location-of-devices-unrelated-to-road-occupation-stage-form.component.html'
})
export class LocationOfDevicesUnrelatedToRoadOccupationStageFormComponent {
  @Input()
  public label: string = '';

  @Input()
  public form: LocationOfDevicesUnrelatedToRoadStageForm | undefined;

  @Input()
  public canRemoveStage = true;

  public serviceId: InputSignal<string | null> = input<string | null>(null);
}
